import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AppModel } from '../../../nextray/Models/AppModel';
import { VwBaseComponent } from '../shared';
import { VwCorrMechanicalComponent } from './vw-corr-mechanical';


/**
 * Correction data of view plan page.
 */
@Component({
	selector: 'vw-correction',
	templateUrl: './vw-correction.component.html',
	imports: [
		VwCorrMechanicalComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class VwCorrectionComponent extends VwBaseComponent {

	model = input.required<AppModel>();
	img = input<string>();

}
